import { render, staticRenderFns } from "./MisTurnos.vue?vue&type=template&id=1ac0ebf6&scoped=true"
import script from "./MisTurnos.vue?vue&type=script&lang=js"
export * from "./MisTurnos.vue?vue&type=script&lang=js"
import style0 from "./MisTurnos.vue?vue&type=style&index=0&id=1ac0ebf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0ebf6",
  null
  
)

export default component.exports